import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { TransitionState } from 'gatsby-plugin-transition-link'
import classNames from 'classnames/bind'

import useUIContext from 'context/ui'

import s from './HorizontalScroll.module.scss'
const cn = classNames.bind(s)

const Tracks = ({ minimal = false }) => {
  const tracksRef = useRef()
  const scrollProgress = useUIContext((s) => s.scrollProgress)

  useEffect(() => scrollProgress.onChange((value) => tracksRef.current.style.setProperty('--progress', value)), [])

  return (
    <TransitionState>
      {({ mount, transitionStatus, current } = {}) => (
        <div className={cn('tracks', transitionStatus, { minimal })} ref={tracksRef}>
          <div className={cn('progress')} />
          <div className={cn('total')} />
        </div>
      )}
    </TransitionState>
  )
}

Tracks.propTypes = {
  minimal: PropTypes.bool,
}

export default Tracks
